import moment from 'moment';
import './AttachChildTranslate';

const styles = {
  textAlign: 'center'
};

export const requestsColumns = ({ t }) => {
  return [
    {
      Header: t('attachChildColumn_numberRequest'),
      style: styles,
      width: 150,
      Cell: row => {
        return row.original?.id ?? '';
      }
    },
    {
      Header: t('attachChildColumn_requesterIIN'),
      style: styles,
      width: 150,
      Cell: row => {
        return row.original?.requesterIin ?? '';
      }
    },
    {
      Header: t('attachChildColumn_requesterFIO'),
      style: styles,
      Cell: row => {
        return row.original?.requesterFullName ?? '';
      }
    },
    {
      Header: t('attachChildColumn_childIin'),
      style: styles,
      width: 150,
      Cell: row => {
        return row.original?.childIin ?? '';
      }
    },
    {
      Header: t('attachChildColumn_date'),
      style: styles,
      Cell: row => {
        return moment(row.original?.createdAt).format('DD.MM.YYYY HH:mm');
      }
    },
    {
      Header: t('attachChildColumn_status'),
      style: styles,
      Cell: row => {
        return t(`attachChildColumn_status_${row.original?.status}`) ?? '';
      }
    },
    {
      Header: t('attachChildColumn_reason'),
      style: styles,
      Cell: row => {
        return row.original?.declineReason ?? '';
      }
    }
  ];
};
